import { Stack } from '@amboss/design-system';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../hooks/redux';
import { setActiveTab } from '../../../store/credits/creditsSlice';
import { HomeSectionsCard } from './HomeSectionsCard';

export const HomeSections = ({ totals }: any) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setActiveTab(0));
  }, []);

  const totalsArray = Object.entries(totals);
  const cardContent = totalsArray?.map((type: any) => {
    return (
      <div key={type} className='home-card-container'>
        <HomeSectionsCard type={type[0]} credits={type[1]} />
      </div>
    );
  });

  return (
    <Stack space={'m'}>
      <section className='home-card-section'>{totalsArray && cardContent}</section>
    </Stack>
  );
};
